var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper", attrs: { id: "login" } }, [
    _c("div", { staticClass: "login-content d-flex justify-content-center" }, [
      _c(
        "div",
        { staticClass: "inner d-flex flex-column justify-content-between" },
        [
          _c("img", {
            staticClass: "branding",
            attrs: { src: "/static/als-logo.png", al: "ALS Logo" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "login-form" }, [
            _c("h2", [_vm._v("New Password")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.passwordOK))]),
            _vm._v(" "),
            _c("form", [
              !this.reset
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Email Address")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.emailAddress,
                          expression: "emailAddress"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "emailAddressField" },
                      domProps: { value: _vm.emailAddress },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.emailAddress = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              !this.reset
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Password")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "password", id: "passwordField" },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              !this.reset
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Please enter again")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password1,
                          expression: "password1"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "password", id: "password1Field" },
                      domProps: { value: _vm.password1 },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password1 = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                !_vm.reset
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        attrs: {
                          type: "button",
                          id: "resetButton",
                          disabled: !_vm.goodToGo
                        },
                        on: { click: _vm.setUserPassword }
                      },
                      [_vm._v("Reset Password")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.reset
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary ml-2",
                        attrs: { type: "button", id: "cancelButton" },
                        on: { click: _vm.backToLogin }
                      },
                      [_vm._v("Cancel")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm.reset
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-block",
                      attrs: { type: "button", id: "backtologinButton" },
                      on: { click: _vm.backToLogin }
                    },
                    [_vm._v("Back to login page")]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "copyright-footer" }, [
            _vm._v("© 2024 Analytica Laboratories Limited T/A ALS NZ")
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "login-image" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2485e70b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2485e70b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ResetPasswordRedemption.vue
// module id = BDt+
// module chunks = 1